import { Currencies } from '@/entities/curency'

const currencyCodeMap: Record<number, string> = {
  [Currencies.RUB]: 'RUB',
  [Currencies.USD]: 'USD',
  [Currencies.USDT]: 'USDT',
}

/**
 * Форматирует сумму в виде "1 000 000 RUB" или "1 000 000.50 USDT"
 * Выводит 2 знака после запятой только если есть дробная часть, иначе без десятичной части
 * Разделяет тысячи пробелами
 * Для нуля выводит "0 RUB" без десятичной части
 * Если currencyNumericCode не указан, возвращает только отформатированную сумму
 */
export function formatCurrency(amount: number, currencyNumericCode?: number): string {
  // Для нуля возвращаем без десятичной части
  if (amount === 0) {
    if (currencyNumericCode === undefined) {
      return '0'
    }
    const currency = currencyCodeMap[currencyNumericCode]
    return currency ? `0 ${currency}` : '0'
  }

  // Определяем количество знаков после запятой
  const fractionDigits = amount % 1 === 0 ? 0 : 2

  // Форматируем число с пробелами в качестве разделителя тысяч и точкой для десятичных
  const formattedAmount = new Intl.NumberFormat('ru-RU', {
    style: 'decimal',
    minimumFractionDigits: fractionDigits,
    maximumFractionDigits: 2,
    useGrouping: true,
  }).format(amount).replace(/,/g, '.')

  if (currencyNumericCode === undefined) {
    return formattedAmount
  }

  const currency = currencyCodeMap[currencyNumericCode]
  if (!currency) {
    return formattedAmount
  }

  return `${formattedAmount} ${currency}`
}
